import * as React from 'react';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';
import UploadElement from './UploadElement';

const Upload = ({ element, elementStyle, updateElement }) => {
  const { formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <UploadElement element={element} updateElement={updateElement} className={className} />
    </FormItem>
  );
};

export default Upload;
